import { useMemo } from "react";
import {
  applyDfyCoupon,
  calculateDfyOrderLineItems,
  sumDfyOrderLineItemCredits,
} from "@repo/api/utils/dfy-billing";
import { useDfyOrderStore } from "@/lib/stores/dfy-order-store/dfy-order-store";
import CostBreakdown from "./CostBreakdown";

export default function DfyStickyCostBreakdown({
  showTitle = true,
}: {
  showTitle?: boolean;
}) {
  const details = useDfyOrderStore((state) => state.order!.details);
  const lineItems = useMemo(
    () => calculateDfyOrderLineItems(details),
    [details],
  );
  const storeCoupon = useDfyOrderStore((state) => state.coupon);
  const coupon = applyDfyCoupon(lineItems, storeCoupon);
  const lineItemCredits = sumDfyOrderLineItemCredits(lineItems);

  if (lineItemCredits <= 0) {
    return null;
  }

  return (
    <CostBreakdown
      lineItems={lineItems}
      coupon={coupon}
      creditsFromBalance={0}
      total={lineItemCredits - (coupon?.credits ?? 0)}
      showTitle={showTitle}
    />
  );
}
